import React,{useState} from 'react';
import { Route ,useRouteMatch,
    useLocation,NavLink,useParams } from 'react-router-dom'
import * as Utils from '../utils';
import InfiniteScroll from 'react-infinite-scroller';
import {Container,Row,Col,Image} from 'react-bootstrap';
import {Parser} from 'html-to-react';

function Detail() {
    let { topicId } = useParams();
    let [content,SetContent]=useState({});
    let [loading,SetLoading] = useState(true);
    React.useEffect(()=>{
        Utils.fetchData(`getnewcontentfull?id=${topicId}`).then(r=>{
            console.log(r)
            SetContent(r)
            SetLoading(false)
            window.scrollTo(0, 0)
        })
    },[topicId]);
    if(loading){
        return<div>Loading...</div>
    }
    document.title = `${content.MCK}: ${content.Title}`
    let p = new Parser();
    let sContent = JSON.parse(content.Content);
    if(sContent.type===0){
        return<div className="bcpt-content">
            <h3>{content.MCK}: {content.Title}</h3>
            <h5 className="news-item-date">{Utils.formatDate(content.CreatedDate)}</h5>
            {
                sContent.Texts.map((e,i)=>(
                    <div key={i}>
                        {p.parse(e)}
                    </div>
                ))
            }
            <div>Tài liệu:</div>
            {
                sContent.LsLink.map((e,i)=>(
                    <div key={i}>
                        <a href={e.Link} target="_blank" rel="noopener noreferrer" download>
                            {e.Title}
                        </a>
                    </div>
                ))
            }
        </div>
    }

    return <div className='news-content'>{p.parse(sContent.wcontent)}</div>
}

const Item=(props)=>{
    let {item,isList} = props;
    const [isError,SetIsError] = React.useState(false);
    return<div className="news-item">
        <div className="news-item-logo">
            {
                isError?<div className="news-comp-logo">
                    {item.MCK}
                </div>:<Image 
                    onError={()=>SetIsError(true)}
                    src={`http://sigmastock.net/Content/compimg/${item.MCK}.jpg`} fluid/>
            }
        </div>
        <div className={!isList?"news-item-content2":"news-item-content"}>
            <h4 className="news-item-title">{item.Title}</h4>
            <h5 className="news-item-date">{Utils.formatDate(item.CreatedDate)}</h5>
        </div>
    </div>
}
const ListItem=(props)=>{
    let match = useRouteMatch();
    let location = useLocation();

    console.log('match',match)
    console.log('location',location)

    let [page,SetPage] = useState(0);
    let [items,SetItems] = useState([]);
    let [isLoading,setIsLoading] = useState(false);
    let [isLoadMore,setIsLoadMore] = useState(true);

    const loadMore = ()=>{
        if(isLoading) return;
        setIsLoading(true);
        Utils.fetchData(`getptdntin?begin=${page*40}&num=40`).then(r=>{
                if(r.length===0){
                    setIsLoadMore(false);
                    return;
                }
                SetPage(page+1)
                SetItems([...items,...r])
                setIsLoading(false);
            }).catch(e=>{
                console.log(e)
            })
    }
    
    let isList = location.pathname===match.path;

    return <Container>
                <Row >
                    <Col md={isList?0:8} xs={12} >
                        <Route path={`${match.path}/:topicId`}>
                            <Detail />
                        </Route>
                    </Col>
                    <Col md={isList?12:4} xs={12} className={'list-news-contain'}>
                        <InfiniteScroll
                            className="list-news"
                            pageStart={0}
                            loadMore={loadMore}
                            hasMore={isLoadMore}
                            loader={<div className="loader" key={0}>Loading ...</div>}
                            useWindow={false}
                            >
                            {
                                items.map(e=><NavLink 
                                    className={isList?'':'list-left-bcpt'}
                                    key={e.Id} to={`${match.path}/${e.Id}`}>
                                        <Item item={e} isList={isList} />
                                    </NavLink>)
                            } 
                        </InfiniteScroll>
                    </Col>
                </Row>
            </Container>
}

const Screen=(props)=>{
    return <ListItem
        title={"Báo cáo Phân Tích"}
    />
}
export default Screen;